import { Component, OnInit, ViewChild, ElementRef, Input, Renderer2 } from '@angular/core';
import { Observable } from 'rxjs';
import { ElearningDashBoardModel, CycleElearning } from '../../../models';
import { CoreService, HttpService } from '../../../services';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-dashboard-item-elearning',
  templateUrl: './dashboard-item-elearning.component.html',
  styleUrls: ['./dashboard-item-elearning.component.css']
})
export class DashboardItemElearningComponent implements OnInit {

  // #region VARIABLES GLOBALES
  // #region public
  public showComponent: boolean;
  public showApprenant: boolean;
  public model: ElearningDashBoardModel;
  public admin: Boolean;
  public Cycles: Observable<Array<CycleElearning>>;
  public showChapters: boolean;
  // #endregion

  // #region useless
  // public searchText: string;
  // #endregion

  // #endregion

  // #region DIRECTIVES
  @Input() id: string;
  @Input() idCpt: string;
  @Input() title: string;
  @ViewChild('parent', { static: false }) parent: ElementRef;
  // #endregion

  // #region CONSTRUCTEUR
  constructor(
    private httpservice: HttpService,
    private indParam: CoreService,
    private render: Renderer2
  ) { }
  // #endregion

  // #region CYCLE DE VIE
  ngOnInit(): void {
    this.showChapters = false;
    this.showComponent = false;
    this.showApprenant = false;
    this.admin = this.indParam.getAutorisation('GestionLeconEL');
    // tslint:disable-next-line:max-line-length
    this.httpservice.getHttp<ElearningDashBoardModel>(`${this.indParam.AppParams.apiUrl}api/elearning/getData/INITDATA/${this.indParam.AppParams.LoggedUser.Ident}|${this.admin}`).subscribe(
      (result: ElearningDashBoardModel) => {
        this.model = result;
        this.showApprenant = !this.admin ? true : false;
        this.showComponent = true;
      }
    );
  }
  // #endregion

  // #region FONCTIONS PUBLIQUES
  selectChange(ident: any): void {
    this.showApprenant = false;
    // tslint:disable-next-line:max-line-length
    this.httpservice.getHttp<ElearningDashBoardModel>(`${this.indParam.AppParams.apiUrl}api/elearning/getData/INITDATA/${ident}|${false}`).subscribe(
      (result: ElearningDashBoardModel) => {
        this.model.Cycles = result.Cycles;
        this.showApprenant = true;
      }
    );
  }

  // showChapter() {
  //   this.showChapters = !this.showChapters;
  //   if (this.showChapters) {
  //     this.render.removeClass(this.chapters.nativeElement, 'hide');
  //     this.render.addClass(this.chapters.nativeElement, 'show');
  //   } else {
  //     this.render.removeClass(this.chapters.nativeElement, 'show');
  //     this.render.addClass(this.chapters.nativeElement, 'hide');
  //   }

  // }
  // #endregion
}
